import Skeleton from '@mui/material/Skeleton';
import { DatagridSkeleton } from 'shared/react-admin/Datagrids';

import {
  BoxStyled,
  StyledCumulativeReportPeriod,
} from './CumulativeReportDatagrid/CumulativeReportDatagrid.styled';

type Props = {
  columnsCount: number;
};

export const CumulativeReportCollapsibleSkeleton: React.FC<Props> = ({ columnsCount }) => (
  <BoxStyled>
    <StyledCumulativeReportPeriod isOpen>
      <Skeleton height={20} variant="rounded" width={360} />
      <Skeleton height={24} sx={{ marginRight: '8px' }} variant="circular" width={24} />
    </StyledCumulativeReportPeriod>
    <DatagridSkeleton columnsCount={columnsCount} />
  </BoxStyled>
);
